export default __webpack_public_path__ + "static/media/under_progress.089c30d5.svg";